import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import uniq from 'lodash/uniq';
import { useSelector } from 'react-redux';

// Constants
import { InputSources } from '../InputSources.constants';
import QueryParamsConstants from 'Shared/constants/QueryParams.constants';

// Types
import { IntegrationSources } from '../types';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';

// Hooks
import { useToggle, useQueryParam } from 'Shared/utils/hooks';
import { useUpdateAiSetting } from 'Shared/utils/hooks/use-update-ai-setting';

// Components
import SourceWrapper from './SourceWrapper';
import AsanaSourceModal from './AsanaSourceModal';

const AsanaSource = () => {
  const { slug } = useParams();
  const history = useHistory();
  const { asanaSourceConfiguration, handleUpdateAiSetting } = useUpdateAiSetting({ slug });

  const [isOpen, toggleIsOpen] = useToggle(false);
  const [showModalOnLoad] = useQueryParam(QueryParamsConstants.SHOW);

  const srcId = IntegrationSources.ASANA;
  const source = InputSources.find(src => src.id === srcId);

  const normalizedData =
    (asanaSourceConfiguration && [
      ...Object.keys(asanaSourceConfiguration)
        .map(key =>
          asanaSourceConfiguration[key].map(value => ({ workspace_id: key.toUpperCase(), project_id: value }))
        )
        .flat(),
    ]) ||
    [];

  const dataSource = useSelector(state => state.data_sources.find(src => src.slug === srcId));
  const { connected } = dataSource;

  const selectedProjectsCount = normalizedData.length;
  const isSelected = selectedProjectsCount > 0;

  const oauthRedirectUrl =
    PageUrlsUtil.makeUpdateAiSettingPageUrl({ slug }) + `?${QueryParamsConstants.SHOW}=${source.id}`;

  const handleUpdate = data => {
    const workspaceKeys = uniq(data.map(d => d.workspace_id));

    const formatted = {};
    workspaceKeys.forEach(key => (formatted[key] = data.filter(d => d.workspace_id === key).map(d => d.project_id)));

    handleUpdateAiSetting({ dataSources: { [srcId]: formatted } });
  };

  useEffect(() => {
    if (showModalOnLoad === source.id) {
      toggleIsOpen();
      history.push(PageUrlsUtil.makeUpdateAiSettingPageUrl({ slug }));
    }
  }, []);

  return (
    <>
      <SourceWrapper
        logo={source.logo}
        name={source.name}
        selected={isSelected}
        onClick={toggleIsOpen}
        connected={connected}
        selectMessage="Select Projects"
        connectedMsg={
          selectedProjectsCount > 1 ? `${selectedProjectsCount} Projects` : `${selectedProjectsCount} Project`
        }
      />
      <AsanaSourceModal
        isOpen={isOpen}
        toggleIsOpen={toggleIsOpen}
        selectedAsanaWorkspaces={normalizedData}
        handleOnChange={handleUpdate}
        oauthRedirectUrl={oauthRedirectUrl}
      />
    </>
  );
};

export default AsanaSource;
